export default {
  SET_ROOM_USER_STICKER(state, stickerData) {
    const userId = stickerData.userId;
    const stickerId = stickerData.stickerId;
    const roomUserList = this.getters['user/roomUserList'];

    const roomUser = roomUserList.find(user => user.userId === userId);
    if (!roomUser) {
      return;
    }

    roomUser.stickerId = stickerId;
  },
  SET_ALL_ROOM_USER_STICKER(state, { stickerId }) {
    const roomUserList = this.getters['user/roomUserList'];
    roomUserList.forEach(user => {
      user.stickerId = stickerId;
    });
  }
}
